import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImportWizardDrugDetailsComponent } from '../components/import-wizard-drug-details/import-wizard-drug-details.component';


@Injectable({
  providedIn: 'root'
})
export class OpenEditWizardService {

  constructor(private dialog : MatDialog) { }

  openDrugDetailsImportWizard(drugId:string, dataSourceId:number, caseNo:string) {
    
        const dialogRef = this.dialog.open(ImportWizardDrugDetailsComponent, {
          backdropClass: ['lgDialog'],
          disableClose: true,
          autoFocus: false,
          data: {
            ndc: drugId,
            dataSourceId: dataSourceId,
            caseNo: caseNo,
          }
        });
        return dialogRef.afterClosed();
      }
}
